/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { subDays, startOfDay, formatISO } from 'date-fns'
import { Link } from 'react-router-dom-v5-compat'
import { Card, CardContent, CardExtra } from '../../Shared/Card'
import { useOpeningTimes, useOverallOpeningTimes } from '../../../Home/OpeningTimes/hooks'
import { OpenRateRadialChart } from '../../../Home/OpeningTimes/OpenRateRadialChart'
import { CardLoadingPlaceholder } from '../../Shared/CardLoadingPlaceholder'
import { isProviderACompany, isProviderAPos } from '../../../../services/Provider/Provider.service'
import useUser from '../../../Shared/UserProvider/useUser'
import { getColor } from '../../../Home/OpeningTimes/openingTimeHelpers'

const OpeningCard = () => {
    const {user} = useUser()
    const from = formatISO(startOfDay(subDays(new Date(), 7)))
    const to = formatISO(startOfDay(new Date()))

    const {data: overallOpeningTimes} = useOverallOpeningTimes({
        from,
        to,
        enabled: isProviderACompany(user.provider)
    })

    const {data: posOpeningTimes} = useOpeningTimes({
        from,
        to,
        page: 1,
        size: 1,
        posIds: isProviderAPos(user.provider) ? [user.pos?.id] : [],
        enabled: isProviderAPos(user.provider)
    })

    const openingRate = isProviderACompany(user.provider) ?
        overallOpeningTimes?.averageOpenRate :
        posOpeningTimes && posOpeningTimes.length > 0 ?
            posOpeningTimes[0].averageOpenRate :
            null

    const getBorderColor = () => {
        if (!openingRate) {
            return 'unset'
        }

        return getColor(openingRate)
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor(openingRate)};
        `}
      >
          <CardContent
            css={css`
                width: 180px;
                height: 120px;
            `}
          >
              {openingRate ?
                <OpenRateRadialChart rate={openingRate} animationsEnabled/> :
                <CardLoadingPlaceholder />
              }
          </CardContent>
          <CardExtra>
              <Link
                to={{
                    pathname: '/analytics/openings/opening-times',
                }}>
                  Ouvertures
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { OpeningCard }
